// Two purely-decorative background layers. Mounted once behind the menu shell.
// CSS (.shell-bg-stars / .shell-bg-orbit) lives in styles.css.
export function ParallaxBackground() {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', inset: 0, zIndex: 0, pointerEvents: 'none' }}>
      <div className="shell-bg-stars" />
      <div className="shell-bg-orbit" />
    </div>
  );
}
